<template>
<!-- is in xero flag -->
    <div>
        <div v-if="showVehicle" class="row mb-4">
            <div class="col-md-3">
                <v-select
                    :options="['Draft','In Xero']"
                    placeholder="All Invoices"
                    v-model="filters.inXero"
                />
            </div>
            <div class="col-md-3" v-if="showOwnedBy">
                <v-select
                    :options="ownerTypes"
                    placeholder="Owned By"
                    v-model="filters.ownedBy"
                />
            </div>
        </div>
        <table ref="table" class="table table-bordered table-striped table-vcenter dataTable">
            <thead>
                <tr>
                    <th v-if="showCustomer">Customer Name</th>
                    <th v-if="showOwnedBy">Owned By</th>
                    <th v-if="showVehicle">Vehicle Details (Vehicle Reg)</th>
                    <th>Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Total (Net Total)</th>
                    <th></th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    </div>
</template>

<script>
import { Eventbus } from '@/components/eventbus';
import VSelect from 'vue-select';

export default {
    components: {
        VSelect,
    },

    props: {
        routes: Object,
        swal_data: {
            type: Object,
            required: false,
        },
        showVehicle: {
            type: Boolean,
            default: true,
        },
        showCustomer: {
            type: Boolean,
            default: true,
        },
        showOwnedBy: false,
        ownerTypes: Array,
    },

    data () {
        return {
            filters: {
                inXero: null,
                ownedBy: null,
            },
        }
    },

    mounted: function () {
        const columns = [];
        if (this.showCustomer) {
            columns.push({
                searchable: false,
                orderable: false,
                data: 'customer_name'
            });
        }
        if (this.showOwnedBy) {
            columns.push({
                data: "vehicle.owned_by"
            });
        }
        if (this.showVehicle) {
            columns.push(
                {
                    name: 'vehicle_description',
                    render: (data, type, row) => {
                        return row.vehicle_description;
                    },
                    sortable: false,
                    searchable: false,
                },
            );
        }
        columns.push(
            {
                data: 'number',
            },
            {
                data: 'date',
                render: function (data) {
                    return new Date(data).toLocaleDateString();
                }
            },
            {
                data: 'net_total',
                render: function (data, type, row) {
                    return '£' + row.total + ' (£' + row.net_total + ')';
                }
            },
            {
                data: 'actions',
            },
            {
                data: 'customer.name',
                visible: false,
                defaultContent: '',
            },
        );
        let table = window.jQuery(this.$refs.table).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.routes.table,
            },
            order: [[3, 'desc']],
            columns: columns,
        });

        Eventbus.on('sales-invoices-table-refresh', () => {
            table.ajax.reload(null, false);
        });

        let adjust = () => {
            this.$refs.table.removeAttribute('style');
            table.columns.adjust();
        };

        if (document.getElementById('vehicle-sales-invoices-tab')) {
            document.getElementById('vehicle-sales-invoices-tab').addEventListener('shown.bs.tab', adjust);
        }

        table.on('draw', adjust);

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );
    },
}
</script>
<style scoped>
    table {
        text-align: left;
    }
</style>
